import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadPcPersonal = () => {
    const promisePcPersonal = new Promise((resolve, reject) => {
        loader.load(
            "office/model/pc/pc.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                model.position.set(0.8392309057574516, 1.9059420067651245, 4.231431813698512);
                model.scale.set(0.4, 0.4, 0.4);
                model.rotation.set(0, -1.3296738425452528, 0);


                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                //ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promisePcPersonal;
};

export { loadPcPersonal };
